module.exports = __webpack_public_path__ + "static/img/banner5.3c6717db.png";